import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import { useCreateSiteRoute } from '../hooks/site-route/useCreateSiteRoute';
import { useSiteContext } from '../SiteContext';
const CreateRouteDialog = ({ open, onCancel, onCreated }) => {
    const [formValues, setFormValues] = useState({});
    const { site } = useSiteContext();
    const { createdRoute, createRoute } = useCreateSiteRoute((site === null || site === void 0 ? void 0 : site.id) || '');
    // const { sendNewRoute } = useSendNewRoute();
    // const { siteRouteComponents, getSiteRoutes } = useGetSiteRoutes();
    // useEffect(() => getSiteRoutes(), [getSiteRoutes]);
    const onCreatedRef = useRef(onCreated);
    useEffect(() => {
        var _a;
        if (createdRoute) {
            // sendNewRoute(createdSiteRouteComponent);
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdRoute);
        }
    }, [createdRoute]);
    return (React.createElement(Dialog, { fullWidth: true, open: open, onClose: onCancel },
        React.createElement(DialogTitle, null, "Create Route"),
        React.createElement("form", { onSubmit: event => {
                event.preventDefault();
                const { name, path } = formValues;
                if (name && path) {
                    createRoute(name, path);
                }
            } },
            React.createElement(DialogContent, null,
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Route Name', value: formValues.name || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { name: event.target.value })) })),
                React.createElement(ConfigFieldControl, null,
                    React.createElement(TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Route Path', placeholder: '/path', value: formValues.path || '', onChange: event => setFormValues(Object.assign(Object.assign({}, formValues), { path: event.target.value })) }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onCancel }, "Cancel"),
                React.createElement(Button, { variant: 'contained', color: 'primary', type: 'submit', disabled: !formValues.name || !formValues.path }, "Submit")))));
};
export default CreateRouteDialog;
//# sourceMappingURL=CreateRouteDialog.js.map